const __WEBPACK_NAMESPACE_OBJECT__ = require("react-qrcode-logo");